import React from "react";
import { Link } from "react-router-dom";
import { cleanAndSubstring } from "../utils/util";

const publicationBodyText = {
  id: {
    title: "Publikasi Kami",
    all: "Semua Publikasi",
    search: "Cari di sini...",
    empty: "Belum ada publikasi yang tersedia.",
    readMore: "Baca Selengkapnya",
    newest: "Baru Terbit",
  },
  en: {
    title: "Our Publications",
    all: "All Publications",
    search: "Search here...",
    empty: "No publications available yet.",
    readMore: "Read More",
    newest: "New Release",
  },
};

const ALL_PUBLICATIONS_CATEGORY = "all";

const getCategoryCount = (category) => {
  const candidates = [
    category.TOTAL,
    category.TOTAL_NEWS,
    category.TOTAL_ITEM,
    category.COUNT,
    category.JUMLAH,
  ];

  const value = candidates.find(
    (candidate) => candidate !== undefined && candidate !== null && candidate !== ""
  );

  return value ? ` (${value})` : "";
};

const buildCategoryList = (categories) => {
  const roots = categories.filter(
    (category) => parseInt(category.PARENT_ID, 10) === 0 || !category.PARENT_ID
  );

  return roots.length ? roots : categories;
};

const findCategoryLabel = (categories, id) => {
  const selected = categories.find(
    (category) => parseInt(category.ID, 10) === parseInt(id, 10)
  );

  return selected ? selected.NAME : "";
};

const getPublicationDetailUrl = (item) => item.PUBLIC_URL || `/publication/${item.SLUG}`;

const publicationPagination = (total, page, perpage, query, categoryQuery) => {
  const totalPages = Math.ceil((total || 0) / (perpage || 1));

  if (totalPages <= 1) {
    return null;
  }

  const params = new URLSearchParams();

  if (query) {
    params.set("s", query);
  }

  if (categoryQuery) {
    params.set("cat", categoryQuery);
  }

  const querySuffix = params.toString() ? `?${params.toString()}` : "";
  const links = [];

  for (let index = 1; index <= totalPages; index += 1) {
    links.push(
      <Link
        key={index}
        to={`/publication/page/${index}${querySuffix}`}
        className={parseInt(page, 10) === index ? "active" : ""}
      >
        {index}
      </Link>
    );
  }

  return (
    <div className="pagination">
      <Link to={`/publication/page/1${querySuffix}`}>&laquo;</Link>
      {links}
      <Link to={`/publication/page/${totalPages}${querySuffix}`}>&raquo;</Link>
    </div>
  );
};

const PublicationListBody = ({
  items,
  page,
  total,
  total_all,
  perpage,
  query,
  categories,
  category_query,
}) => {
  const lang = window.lang || "id";
  const copy = publicationBodyText[lang] || publicationBodyText.id;
  const publicationCategories = buildCategoryList(categories || []);
  const allPublicationsCount =
    total_all !== undefined && total_all !== null ? ` (${total_all})` : "";
  const selectedCategory = category_query || ALL_PUBLICATIONS_CATEGORY;
  const buildPublicationQuery = (categoryId) => {
    const params = new URLSearchParams();

    if (query) {
      params.set("s", query);
    }

    if (categoryId && categoryId !== ALL_PUBLICATIONS_CATEGORY) {
      params.set("cat", categoryId);
    }

    const queryString = params.toString();

    return queryString ? `?${queryString}` : "";
  };

  return (
    <section className="publication-list-section">
      <div className="container">
        <div className="publication-list-toolbar">
          <form action="/publication/page/1" method="get" className="publication-search-form">
            {selectedCategory !== ALL_PUBLICATIONS_CATEGORY ? (
              <input type="hidden" name="cat" value={selectedCategory} />
            ) : null}
            <input
              type="text"
              name="s"
              defaultValue={query || ""}
              className="publication-search-input"
              placeholder={copy.search}
            />
          </form>
        </div>
        <div className="row">
          <div className="col-lg-4 col-xl-3 mb-4 mb-lg-0">
            <aside className="publication-sidebar">
              <Link
                to={`/publication/page/1${buildPublicationQuery(ALL_PUBLICATIONS_CATEGORY)}`}
                className={`publication-category-link ${
                  selectedCategory === ALL_PUBLICATIONS_CATEGORY ? "active" : ""
                }`}
              >
                {copy.all}
                {allPublicationsCount}
              </Link>
              {publicationCategories.map((category) => (
                <Link
                  to={`/publication/page/1${buildPublicationQuery(`${category.ID}`)}`}
                  key={category.ID}
                  className={`publication-category-link ${
                    parseInt(selectedCategory, 10) === parseInt(category.ID, 10)
                      ? "active"
                      : ""
                  }`}
                >
                  {category.NAME}
                  {getCategoryCount(category)}
                </Link>
              ))}
            </aside>
          </div>
          <div className="col-lg-8 col-xl-9">
            {items && items.length ? (
              <div>
                {items.map((item, index) => (
                  <article className="publication-card" key={item.ID}>
                    <a
                      href={`/publication/${item.SLUG}`}
                      className="publication-cover-link"
                    >
                      <img
                        src={item.FULL_PATH_IMAGE}
                        alt={item.TITLE}
                        className="publication-cover"
                      />
                    </a>
                    <div className="publication-card-body">
                      <div className="publication-meta-row">
                        <span className="publication-category-pill">
                          {findCategoryLabel(categories || [], item.CATEGORY_ID) ||
                            item.CATEGORY ||
                            item.CATEGORY_NAME ||
                            "Publication"}
                        </span>
                        {index === 0 ? (
                          <span className="publication-status-pill">{copy.newest}</span>
                        ) : null}
                      </div>
                      <a
                        href={getPublicationDetailUrl(item)}
                        className="publication-card-title"
                        target={item.PUBLIC_URL ? "_blank" : undefined}
                        rel={item.PUBLIC_URL ? "noopener noreferrer" : undefined}
                      >
                        {item.TITLE}
                      </a>
                      <p className="publication-card-excerpt">
                        {cleanAndSubstring(item.DESC_NEWS || "", 220)}...
                      </p>
                      <a
                        href={`/publication/${item.SLUG}`}
                        className="publication-card-link"
                      >
                        {copy.readMore}
                      </a>
                    </div>
                  </article>
                ))}
                <div className="publication-pagination">
                  {publicationPagination(total, page, perpage, query, category_query)}
                </div>
              </div>
            ) : (
              <div className="publication-empty-state">{copy.empty}</div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PublicationListBody;
